import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Table, Form, Input, InputNumber, Modal, message } from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const KnowledgeBase = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [tableSource, setTableSource] = useState({});
  const [inputList] = useState([
    {
      label: "设备名称:",
      name: "classifyName",
      message: "请输入设备名称",
      span: 8,
      labelCol: 6,
    },
  ]);

  const columns = [
    {
      title: "名称",
      dataIndex: "classifyName",
      align: "center",
      key: "classifyName",
    },
    {
      title: "排序",
      dataIndex: "sort",
      align: "center",
      key: "sort",
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (text) => RenderTxt(text),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getListPages = () => {
    setLoading(true);
    SystemApi.deviceClassifyList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.deviceClassifyRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getListPages();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    setVisible(true);
    setEditId(obj.id);
    form.setFieldsValue({ ...obj });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = { ...values };
      if (editId) {
        setConfirmLoading(true);
        SystemApi.deviceClassifyUpdate({ ...params, id: editId }).then(
          (res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancel();
            getListPages();
          }
        );
      } else {
        setConfirmLoading(true);
        SystemApi.deviceClassifyAdd(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    setSearchParams({
      ...values,
      pageNum: 1,
      pageSize: 10,
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm span={6} inputList={inputList} onSearch={search} />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={() => setVisible(true)}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="分类名称"
              name="classifyName"
              rules={[{ required: true, message: "请输入分类名称!" }]}
            >
              <Input placeholder="请输入分类名称" />
            </Form.Item>
            <Form.Item
              label="排序"
              name="sort"
              rules={[{ required: true, message: "请输入排序!" }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="请输入排序" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(KnowledgeBase);
